<vc-copy-button
    class="vc-json-viewer-copy"
    [tooltipText]="'COMMON_UI.COPY' | transloco"
    tooltipPosition="left"
    [value]="json | json"
    [showNotification]="true"></vc-copy-button>
<json-viewer [json]="json" [expanded]="expanded"></json-viewer>
